<template>
    <a class="button-return" @click="back" :class="{disabled: noshow === true}">
      <img src="media/global/btn_return.png"/>
      <div class="button-title">{{this.$store.state.items.buttons.returnButton}}</div>
    </a>
</template>

<script>
  export default {
    data() {
      return {

      }
    },
    computed: {
      location () {
        return this.$store.state.scormLMS.location
      },
      noshow () {
        if (this.$store.state.scormLMS.location <= 2 ||
            this.$store.state.scormLMS.location >= 5) {
          return true
        } else return false
      }
    },
    methods: {
      back() {
        this.$store.commit('scormLMS/locationMinus');
      }
    },
    components: {},
    props: ['items']
  }

</script>

<style scoped>
.button-return {
  position: absolute;
  top: 105px;
  left: -65px;
  z-index: 990;
  cursor: pointer;
  user-select: none;
  -webkit-filter: drop-shadow(2px 2px 2px #222 );
  filter: drop-shadow(2px 2px 2px #222);
}
.button-return.disabled {
  display: none;
  pointer-events: none;
  cursor: default;
}
.button-title {
  font-family: 'Nunito', sans-serif;
  position: absolute;
  bottom: 12px;
  left: 100px;
  z-index: 999;
  font-size: 14px;
  text-decoration: none;
  color: white;
  font-weight: bold;
}

</style>



// WEBPACK FOOTER //
// ButtonReturn.vue?0a140247